import React from 'react'

/**
 * Hook that executes a callback after a delay when a condition is met
 */
export function useTimeoutEffect(
  callback: () => void,
  condition: boolean,
  deps: React.DependencyList,
  delay: number = 0,
) {
  React.useEffect(() => {
    if (condition) {
      const timeout = setTimeout(callback, delay)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, deps)
}
